/***
 * @file:
 * @author: haoxianhuan
 * @Date: 2021-07-26 19:55:43
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { DtTinymceEditorModule } from '@ithinkdt/shared/editor';
import { DtTableModule } from '@ithinkdt/shared/table';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { EditorRichModule } from './form-base/editor-rich/editor-rich.module';

import { FileUploadComponent } from './file-upload/file-upload.component';
// æ°çæ¬å¨æè¡¨å
import { FormBaseComponent } from './form-base/form-base.component';
import { FormButtonComponent } from './form-base/form-button/form-button.component';
import { FormCheckboxComponent } from './form-base/form-checkbox/checkbox.component';
import { FormDatePickerComponent } from './form-base/form-date-picker/form-date-picker.component';
import { FormInputComponent } from './form-base/form-input/form-input.component';
import { FormRadioComponent } from './form-base/form-radio/radio.component';
import { FormRichEditorComponent } from './form-base/form-rich-editor/form-rich-editor.component';
import { FormSelectComponent } from './form-base/form-select/form-select.component';
import { FormSwitchComponent } from './form-base/form-switch/switch.component';
import { FormUploadComponent } from './form-base/form-upload/form-upload.component';
import { FormSearchSelectComponent } from './form-search-select/form-search-select.component';
import { FormSearchComponent } from './form-search/form-search.component';
import { UploadBaseComponent } from './upload-base/upload-base.component';

import { DatePickerBorderLineDirective } from './date-picker-border-line-color.directive';
import { DisableControlDirective } from './disable-control.directive';

import { BaseLayoutComponent } from './base-layout/base-layout.component';
import { FormSearchService } from './fetch/form-fetch.service';
import { FormCardUploadComponent } from './form-base/form-card-upload/form-card-upload.component';
import { DtNzInputNumberComponent } from './form-base/form-input/input-number.component';
import { FormCarouselComponent } from './form-carousel/form-carousel.component';
import { TableBaseComponent } from './table-base/table-base.component';
import { TableItemComponent } from './table-item/table-item.component';

const FORM_COMPONENTS = [
  FileUploadComponent,
  FormSearchSelectComponent,
  FormSearchComponent,
  UploadBaseComponent,
  // Form base
  FormBaseComponent,
  FormCheckboxComponent,
  FormDatePickerComponent,
  FormInputComponent,
  FormRadioComponent,
  FormRichEditorComponent,
  FormSelectComponent,
  FormSwitchComponent,
  FormUploadComponent,
  TableItemComponent,
  TableBaseComponent,
  FormButtonComponent,
  FormCarouselComponent,
  FormCardUploadComponent,
  DtNzInputNumberComponent,
  BaseLayoutComponent,
];

// æä»¤
const FORM_DIRECTIVE = [DisableControlDirective, DatePickerBorderLineDirective];
const NZ_MODULES = [
  NzToolTipModule,
  NzButtonModule,
  NzModalModule,
  NzUploadModule,
  NzGridModule,
  NzTableModule,
  NzCardModule,

  NzCheckboxModule,
  NzDatePickerModule,
  NzInputModule,
  NzInputNumberModule,
  NzRadioModule,
  NzSelectModule,
  NzTreeSelectModule,
  NzCascaderModule,
  NzSwitchModule,
  NzFormModule,
  NzTimePickerModule,
  NzDropDownModule,
  // å¯ææ¬ç¼è¾å¨
  EditorRichModule,
  // å°è¦æ¿æ¢
  NzIconModule,
];

const FORM_SERVICE = [FormSearchService];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    DtTableModule,
    DtTinymceEditorModule,
    ...NZ_MODULES,
  ],
  declarations: [...FORM_DIRECTIVE, ...FORM_COMPONENTS],
  exports: [...FORM_DIRECTIVE, ...FORM_COMPONENTS],
  providers: [...FORM_SERVICE],
})
export class DtFormModule {}
